// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2Gc0G","title":"ClientInsurance_title__rPZWE","itemText":"ClientInsurance_itemText__3KkMS"};